import Titulo from "../../generico/TituloPagina";
import ConfirmarOperacionSolicitud from "./ConfirmarOperacionSolicitud";
import DatosSocio from "../../generico/DatosSocio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { generarTarjetaDebito, getSucursales, getTipoTarjeta } from "../../../services/solicitudes/SolicitudTarjetaDebitoService";
import TarjetaCreditoCU from "../../generico/Tarjeta/TarjetaCreditoCU"
import Popup from "react-popup";
import CuentaSocioTransferencia from "../../generico/CuentaSocioTransferencia";
import TransferCuentasPropiasService from "../../../services/transferencias/TransferCuentasPropiasService";
import { trackPromise } from "react-promise-tracker";

function TarjetaDebito() {
  const tokenActivo = sessionStorage.getItem('tieneToken');
  const modalCtrlConfirm = useRef(null);
  function loadDataConfirm() {
    var cuentaOrigen = cuentasOrigen.find(item => item.ahorro === datosSolicitud.idAhorro);
    var cuentaOrigenDesc = `${cuentaOrigen.ahorro}-${cuentaOrigen.descripcion}`;
    var tipoTarjetaDesc = tipoTarjetas.find(item => item.value === datosSolicitud.tipoTarjeta).label;
    var sucursalDesc = sucursales.find(item => item.value === datosSolicitud.numeroSucursal).label;
    var itemsConfirm = [
      { concepto: "Cuenta", valor: cuentaOrigenDesc },
      { concepto: "Sucursal", valor: sucursalDesc },
      { concepto: "Tipo Tarjeta", valor: tipoTarjetaDesc },
    ];
    setItemsConfirm(itemsConfirm)
    modalCtrlConfirm.current.click();
  }

  const [itemsConfirm, setItemsConfirm] = useState();
  const [cuentasOrigen, setCuentasOrigen] = useState(
    []
  );
  const [tipoTarjetas, setTipoTarjetas] = useState();
  const [sucursales, setSucursales] = useState();
  const [datosSolicitud, setDatosSolicitud] = useState(
    {
      idAhorro: "",
      operador: "",
      numeroSucursal: "",
      tipoTarjeta: ""
    });

  useEffect(() => {
    console.log(datosSolicitud);
  }, [datosSolicitud]);
  function onChangeTipoTarjeta(value, param2) {
    setDatosSolicitud({
      ...datosSolicitud,
      tipoTarjeta: value
    });
  }

  function onChangeSucursales(value) {
    setDatosSolicitud({
      ...datosSolicitud,
      numeroSucursal: value
    });
  }

  function onChangeCuenta(value, param2) {
    console.log(value, param2)
    setDatosSolicitud({
      ...datosSolicitud,
      idAhorro: value.ahorro
    });
  }
  useEffect(() => {
    getTipoTarjeta().then((response) => {
      const opcionesTipoTarjeta = [];
      var data = JSON.stringify(response.data);
      var jsonData = JSON.parse(data);

      if (jsonData.codigo === 0) {
        for (var i = 0; i < jsonData.datos.length; i++) {
          opcionesTipoTarjeta.push({
            value: jsonData.datos[i].marca.charAt(0),
            label:
              jsonData.datos[i].marca,
          });
        }
      } else {
        Popup.queue(notifiPopup("Error", jsonData.desRetorno));
        return;
      }
      console.log(response);
      setTipoTarjetas(opcionesTipoTarjeta);
    });

    getSucursales().then((response) => {
      const opcionesSucursales = [];
      var data = JSON.stringify(response.data);
      var jsonData = JSON.parse(data);

      if (jsonData.codigo === 0) {
        for (var i = 0; i < jsonData.datos.length; i++) {
          opcionesSucursales.push({
            value: jsonData.datos[i].codigo.toString(),
            label:
              jsonData.datos[i].descripcion,
          });
        }
      } else {
        Popup.queue(notifiPopup("Error", jsonData.desRetorno));
        return;
      }
      console.log(response);
      setSucursales(opcionesSucursales);
    });

    TransferCuentasPropiasService.getCuentas("D").then((response) => {
      var data = JSON.stringify(response.data);
      var jsonData = JSON.parse(data);
      var cuentasDebitar = jsonData.resultadoAH.filter(cuenta => cuenta.moneda === "GS");
      setCuentasOrigen(cuentasDebitar)
    });
  }, []);

  function confirmarGenerarTarjetaDebito() {
    trackPromise(
      generarTarjetaDebito(datosSolicitud)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          var mensaje = "";

          console.log(data);

          mensaje = jsonData.mensaje ?? "Ocurrió un error al enviar la solicitud";
          if (jsonData.datos?.pasar === "N") {
            mensaje = jsonData.datos?.mensaje ?? mensaje
          } else if (jsonData.codigo === 0) {
            mensaje = "Solicitud enviada con éxito";
          }

          Popup.create({
            title: "Solicitud de Tarjeta de Débito",
            content: mensaje,
            buttons: {
              right: [{
                text: 'Aceptar',
                className: 'success',
                action: function () {
                  Popup.close();
                  window.location.reload();
                }
              }]
            }
          });
        })
    );
  }

  const notifiPopup = (titulo, mensaje) => {
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  };

  return (
    <div className="content-wrapper">
      <ConfirmarOperacionSolicitud
        idModal="idModalConfirm"
        title="Solicitud de Tarjeta de Debito"
        items={itemsConfirm}
        confirmarBtn={confirmarGenerarTarjetaDebito}
      />
      <Titulo texto="Solicitud de Tarjeta de Debito" />
      <section className="content">
        <form id="idTCForm" onSubmit={(e) => {
          e.preventDefault();

        }}>
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  {tokenActivo === "N" &&
                    <div className="col-12">
                      <div className="card card-aviso-completo">
                        <div className="card-header card-aviso">
                          <h3 className="title-aviso">Estimado Socio:</h3>
                        </div>
                        <div className="card-body">
                          <p>Recuerde que firmar el Contrato Único y gestionar su Token, le permitirá acceder a mayores
                            beneficios y seguridad en sus transacciones. Le esperamos en cualquiera de nuestras Sucursales.</p>
                        </div>
                      </div>
                    </div>}
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-7">
                        <CuentaSocioTransferencia
                          renderMonto="false"
                          selectorValue={onChangeCuenta}
                          montoValue={0}
                          operacion="DEBITO"
                          tipoCuenta="AHORRO_VISTA"
                          items={cuentasOrigen}
                        // monto={this.state.monto}
                        // itemSelected={this.state.itemSelected}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-7">
                        {<TarjetaCreditoCU titulo="Tipo de tarjeta" presentacion="SELECT" selectorValue={onChangeTipoTarjeta} itemSelected={null} tarjetas={tipoTarjetas} />}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-7">
                        {<TarjetaCreditoCU titulo="Sucursales" presentacion="SELECT" selectorValue={onChangeSucursales} itemSelected={null} tarjetas={sucursales} />}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="row">
                      <div className="col-lg-10 col-md-8">
                        <label className="input-label-bold-obligatorio">
                          (*) Campos Obligatorios
                        </label>
                      </div>
                      <div className="col-lg-2 col-md-4">
                        <button className="btn btn-cu-primary float-right" onClick={() => loadDataConfirm()}>
                          <FontAwesomeIcon icon={faPaperPlane} /> Enviar
                        </button>
                        <a
                          ref={(a) => (modalCtrlConfirm.current = a)}
                          href="#"
                          hidden
                          id="modalCtrlConfirm"
                          data-toggle="modal"
                          data-target="#idModalConfirm"
                        ></a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
}

export default TarjetaDebito;
